var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_248",
    "data-name": "Group 248",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M0,0H22V22H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M12,12.083V17.2l1.676-1.676,1.3,1.3-3.889,3.889L7.193,16.824l1.3-1.3L10.166,17.2v-5.12ZM11.083,2a6.418,6.418,0,0,1,6.374,5.678,5.042,5.042,0,0,1-.874,9.886V15.717a3.208,3.208,0,1,0-1.019-6.335,4.583,4.583,0,1,0-8.962,0A3.208,3.208,0,0,0,5.418,15.69l.165.028v1.846a5.042,5.042,0,0,1-.874-9.885A6.417,6.417,0,0,1,11.083,2Z",
    transform: "translate(-0.083 -0.167)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSave);
export default __webpack_public_path__ + "static/media/cloudSave.f6e56f7f19281fe6fc919cea93a27c16.svg";
export { ForwardRef as ReactComponent };